module.exports = __webpack_public_path__ + "img/close.ad76f393.svg";